import { ExternalLink } from "lucide-react";

import { quickbooksTxnUrl, type QuickBooksTxnKind } from "@/lib/quickbooksTxnUrl";
import { EM_DASH } from "@/lib/utils";

export function QuickBooksBillTextLink({
  txnId,
  documentLabel,
}: {
  txnId: string | null | undefined;
  documentLabel: string;
}): JSX.Element | null {
  const href = quickbooksTxnUrl("bill", txnId ?? "");
  if (href == null) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      className="text-xs font-medium text-brand-700 hover:underline"
      aria-label={`Open ${documentLabel} in QuickBooks`}
    >
      QuickBooks
    </a>
  );
}

export function QuickBooksTxnLink({
  txnId,
  kind,
  documentLabel,
}: {
  txnId: string | null | undefined;
  kind: QuickBooksTxnKind;
  documentLabel: string;
}): JSX.Element {
  const id = txnId?.trim() ?? "";
  const href = id === "" ? null : quickbooksTxnUrl(kind, id);
  if (href == null) {
    return <>{EM_DASH}</>;
  }
  return (
    <span className="inline-flex min-w-0 items-center gap-1.5">
      <span className="font-mono text-xs">{id}</span>
      <a
        href={href}
        target="_blank"
        rel="noreferrer noopener"
        className="shrink-0 text-brand-600 hover:text-brand-700"
        aria-label={`Open ${documentLabel} in QuickBooks`}
      >
        <ExternalLink className="h-3.5 w-3.5" aria-hidden />
      </a>
    </span>
  );
}
